import { Component, OnInit } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { TranslateTextPipe } from 'src/app/shared/pipes/translateText.pipe';
import { GridTableParametersService } from './../../template/gridTemplate/gridTableParameters.service';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.css']
})
export class WelcomePageComponent implements OnInit {
  resourceDefinition: any;
  showForgotPwd = false;
  gipDefault;
  enableRegister: boolean;
  enableForgotPassword: boolean = false;
  mailToRegister;
  mailToRegisterValue;

  constructor(
    private shareData: SharingDataService,
    public grid: GridTableParametersService,
    private translateText: TranslateTextPipe,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
  ) { }

  selected = 0;

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentGipDefault.subscribe(data => this.gipDefault = data);

    this.enableRegister = this.translateText.transform("USERREGISTER", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? true : false;
    this.enableForgotPassword = this.translateText.transform("ALLOWPASRESET", this.gipDefault, "GIP_NAME", "GIP_VALUE") == "true" ? true : false;
    this.mailToRegister = this.translateText.transform("MAILTOREGISTER", this.gipDefault, "GIP_NAME", "GIP_VALUE");
    this.mailToRegisterValue = `mailto:${this.mailToRegister}`;
  }

  changeShowForgotPwd(){
  this.showForgotPwd = this.showForgotPwd == true ? false : true;
  }

  setSelected(page){
    this.selected = page;
  }

  moveToLoginFromRegister(){
    this.selected = 0;
  }
}
